<mat-form-field appearance="fill">
  <mat-label>{{ texts.report.week | translate }}</mat-label>
  <input
    matInput
    [matDatepicker]="dp"
    (keydown.arrowDown)="previousWeek($event)"
    (keydown.arrowUp)="nextWeek($event)"
    [formControl]="date"
    (dateChange)="onChange()"
  />
  <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
  <mat-datepicker
    #dp
    (yearSelected)="chosenYearHandler($event)"
    (monthSelected)="chosenMonthHandler($event, dp)"
    panelClass="example-month-picker"
  >
  </mat-datepicker>
</mat-form-field>
